/** Catalog drill used when a King of the Table block has no exercise yet. */
export const KOT_MATCH_SIMULATION_NAMES = Object.freeze({
  en: "Match Simulation",
  fr: "Simulation de match",
  de: "Matchsimulation",
  es: "Simulación de partido",
});

function normalizeName(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase();
}

const MATCH_SIMULATION_ALIASES = new Set(
  Object.values(KOT_MATCH_SIMULATION_NAMES).map(normalizeName)
);

export function isKotMatchSimulationName(value) {
  return MATCH_SIMULATION_ALIASES.has(normalizeName(value));
}

export function isKotMatchSimulationExercise(ex) {
  if (!ex) return false;
  return [
    ex.ex_name_en,
    ex.ex_name_fr,
    ex.ex_name_de,
    ex.ex_name_es,
    ex.ex_name,
  ].some(isKotMatchSimulationName);
}

/** Prefer the English catalog name, then any localized alias. */
export function pickKotMatchSimulationExercise(list) {
  const rows = Array.isArray(list) ? list.filter(Boolean) : [];
  return (
    rows.find((row) => isKotMatchSimulationName(row.ex_name_en)) ||
    rows.find(isKotMatchSimulationExercise) ||
    null
  );
}
